export const YubiKey = 1; // YubiKey
export const VipAccess = 2; // Symantec VIP Access
export const OLProtect = 8; // OneLogin Protect
export const GoogleAuth = 10; // Google Authenticator
export const OLSMS = 11; // OneLogin SMS
export const OLSQ = 13; // OneLogin Security Questions
export const OLVoice = 17; // OneLogin Voice
export const OLEmail = 19; // OneLogin Email
